// ✅ UPDATED — src/pages/Dashboard.jsx
// ✅ UX: Keep input focused on first mount and when active chat changes
// ✅ FIX: Dashboard does NOT remount ChatInterface on session switch (prevents first-turn “fly away” + missing first Lexa reply)

import React, { useEffect, useRef } from "react";
import ChatInterface from "../components/ChatInterface";
import SearchChatModal from "../components/SearchChatModal";

const Dashboard = ({
  chatList,
  handleSelectChat,
  showSearchModal,
  setShowSearchModal,
  activeChat,
  setActiveChat,
}) => {
  const chatRef = useRef(null);

  // ✅ Focus on mount
  useEffect(() => {
    try {
      if (chatRef.current) chatRef.current.focus();
    } catch {}
  }, []);

  // ✅ Focus again whenever user switches sessions
  useEffect(() => {
    try {
      if (chatRef.current) chatRef.current.focus();
    } catch {}
  }, [activeChat?.session_id]);

  return (
    <section style={styles.chatSection}>
      <div style={styles.chatContainer}>
        <ChatInterface
          inputRef={chatRef}
          activeChat={activeChat}
          setActiveChat={setActiveChat}
          chatList={chatList}
          onSelectChat={handleSelectChat}
        />
      </div>

      {showSearchModal && (
        <SearchChatModal
          chatList={chatList}
          onSelectChat={(chat) => {
            // Keep your existing behavior
            handleSelectChat?.(chat);
            setActiveChat?.(chat);
            setShowSearchModal?.(false);
          }}
          onClose={() => setShowSearchModal?.(false)}
        />
      )}
    </section>
  );
};

const styles = {
  chatSection: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minHeight: 0,
    overflow: "hidden",
  },

  chatContainer: {
    width: "100%",
    maxWidth: "100%",
    flexGrow: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "stretch",
    margin: "0 auto",
    boxSizing: "border-box",
    overflow: "hidden",
  },
};

export default Dashboard;
